export default "__VITE_ASSET__BszySxSO__"